import React, { useEffect, useState } from "react";
import bgImage from "../assets/images/bg-01.jpg";
import axios from "axios";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaBuilding,
  FaPaperPlane,
  FaHeadset,
  FaClock,
  FaShieldAlt,
} from "react-icons/fa";
import { BASE_URL } from "../config/config";

const Contact = () => {
  const [form, setForm] = useState({
    email: "",
    phoneNo: "",
    message: "",
  });

  const [contact, setContact] = useState([]);

  
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]:
        name === "phoneNo"
          ? value.replace(/[^0-9]/g, "").slice(0, 10)
          : value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${BASE_URL}/contact`, form);

      alert(response.data.message);

      setForm({
        email: "",
        phoneNo: "",
        message: "",
      });
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.glamiraa.in/companyDetails"
        );

        setContact(res.data.data);
      } catch (err) {}
    };

    fetchData();
  }, []);

  return (
    <>
      {/* Hero */}

      <section
        className="position-relative d-flex align-items-center justify-content-center text-center"
        style={{
          backgroundImage: `linear-gradient(rgba(15,23,42,.75), rgba(15,23,42,.75)), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "420px",
        }}
      >
        <div className="container">

          <h1 className="display-3 fw-bold text-white mb-3">
            Get In Touch
          </h1>

          <p
            className="text-white mx-auto"
            style={{
              maxWidth: "700px",
              fontSize: "20px",
            }}
          >
            We'd love to hear from you. Whether you have questions about
            products, orders, payments, or anything else, our team is always
            ready to help.
          </p>

        </div>
      </section>

      {/* Quick Features */}

      <section className="py-5 bg-light">
        <div className="container">

          <div className="row g-4">

            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 text-center p-4 h-100">
                <FaHeadset
                  size={45}
                  className="mx-auto text-primary mb-3"
                />
                <h5 className="fw-bold">24/7 Customer Support</h5>
                <p className="text-muted">
                  Dedicated assistance for all your shopping queries.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 text-center p-4 h-100">
                <FaShieldAlt
                  size={45}
                  className="mx-auto text-success mb-3"
                />
                <h5 className="fw-bold">Secure Communication</h5>
                <p className="text-muted">
                  Your information is protected and handled securely.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 text-center p-4 h-100">
                <FaClock
                  size={45}
                  className="mx-auto text-warning mb-3"
                />
                <h5 className="fw-bold">Quick Response</h5>
                <p className="text-muted">
                  We strive to respond to all inquiries as soon as possible.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Contact Section */}

      <section
        style={{
          background: "#f8fafc",
          padding: "80px 0",
        }}
      >
        <div className="container">

          <div className="row g-5 align-items-stretch">

            {/* Contact Form */}

            <div className="col-lg-7">

              <div className="card border-0 shadow-lg rounded-4 h-100">

                <div className="card-body p-5">

                  <h2 className="fw-bold mb-2">
                    Send Us a Message
                  </h2>

                  <p className="text-muted mb-4">
                    Fill out the form below and our team will get back to you
                    as soon as possible.
                  </p>

                  <form onSubmit={handleSubmit}>

                    <div className="mb-4">

                      <label className="form-label fw-semibold">
                        Email Address
                      </label>

                      <div className="input-group">

                        <span className="input-group-text bg-white">
                          <FaEnvelope />
                        </span>

                        <input
                          type="email"
                          className="form-control py-3"
                          placeholder="Enter your email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />

                      </div>

                    </div>

                    <div className="mb-4">

                      <label className="form-label fw-semibold">
                        Phone Number
                      </label>

                      <div className="input-group">

                        <span className="input-group-text bg-white">
                          <FaPhoneAlt />
                        </span>

                        <input
                          type="tel"
                          className="form-control py-3"
                          placeholder="Enter phone number"
                          minLength={10}
                          maxLength={10}
                          pattern="[0-9]{10}"
                          inputMode="numeric"
                          name="phoneNo"
                          value={form.phoneNo}
                          onChange={handleChange}
                        />

                      </div>

                    </div>

                    <div className="mb-4">

                      <label className="form-label fw-semibold">
                        Message
                      </label>

                      <textarea
                        className="form-control"
                        rows="6"
                        placeholder="Tell us how we can help..."
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        required
                      />

                    </div>

                    <button
                      className="btn btn-primary btn-lg rounded-pill px-5"
                      type="submit"
                    >
                      <FaPaperPlane className="me-2" />
                      Send Message
                    </button>

                  </form>

                </div>

              </div>

            </div>

            {/* Contact Details */}

            <div className="col-lg-5">

              {contact.map((item) => (
                <div
                  key={item.site_id}
                  className="card border-0 shadow-lg rounded-4 h-100"
                >
                  <div className="card-body p-5">

                    <h2 className="fw-bold mb-4">
                      Contact Information
                    </h2>

                    <div className="d-flex mb-4">

                      <FaBuilding
                        size={22}
                        className="text-primary me-3 mt-1"
                      />

                      <div>

                        <h6 className="fw-bold mb-1">
                          Company
                        </h6>

                        <p className="text-muted mb-0">
                          {item.company_Name}
                        </p>

                      </div>

                    </div>

                    <div className="d-flex mb-4">

                      <FaMapMarkerAlt
                        size={22}
                        className="text-danger me-3 mt-1"
                        style={{
                          width: 100
                        }}
                      />

                      <div>

                        <h6 className="fw-bold mb-1">
                          Address
                        </h6>

                        <p className="text-muted mb-0">
                          {item.address}
                        </p>

                      </div>

                    </div>

                    <div className="d-flex mb-4">

                      <FaPhoneAlt
                        size={20}
                        className="text-success me-3 mt-1"
                      />

                      <div>

                        <h6 className="fw-bold mb-1">
                          Phone
                        </h6>

                        <a
                          href={`tel:${item.contact_phone}`}
                          className="text-decoration-none"
                        >
                          {item.contact_phone}
                        </a>

                      </div>

                    </div>

                    <div className="d-flex">

                      <FaEnvelope
                        size={20}
                        className="text-warning me-3 mt-1"
                      />

                      <div>

                        <h6 className="fw-bold mb-1">
                          Email
                        </h6>

                        <a
                          href={`mailto:${item.contact_email}`}
                          className="text-decoration-none"
                        >
                          {item.contact_email}
                        </a>

                      </div>

                    </div>

                    <hr className="my-4" />

                    <div
                      className="rounded-4 p-4 text-center text-white"
                      style={{
                        background:
                          "linear-gradient(135deg,#2563eb,#1d4ed8)",
                      }}
                    >
                      <h5 className="fw-bold">
                        Customer Satisfaction First
                      </h5>

                      <p className="mb-0">
                        We value every customer and aim to provide quick,
                        transparent, and reliable support for every inquiry.
                      </p>
                    </div>

                  </div>
                </div>
              ))}

            </div>

          </div>

          {/* Bottom CTA */}

          <div className="text-center mt-5">

            <h2 className="fw-bold">
              We're Here to Help
            </h2>

            <p
              className="text-muted mx-auto"
              style={{
                maxWidth: "700px",
              }}
            >
              Whether you need assistance before placing an order or after
              receiving your purchase, our dedicated support team is committed
              to ensuring a smooth and satisfying shopping experience.
            </p>

          </div>

        </div>
      </section>
    </>
  );
};

export default Contact;